<template>
  <div>
    <div class="mb-6 flex justify-between items-center">
      <h1 class="mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('batches')">Lotti</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.nome }}
      </h1>
      <trashed-message v-if="batch.deleted_at" class="mb-6" @restore="restore"> Questo lotto è stato cancellato. </trashed-message>
      <a v-if="user.id == 1 || user.id == 3 || user.id == 18" class="btn-indigo" :href="route('export', [this.batch.id, this.batch.nome])">
        <span>Esporta</span>
        <span class="hidden md:inline">Prodotti</span>
      </a>
    </div>
    <!-- <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.nome" :error="form.errors.nome" class="pr-6 pb-8 w-full lg:w-1/2" label="Nome" /> -->
    <!-- <select-input v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Magazzino">
            <option :value="null" />
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name }}</option>
          </select-input>
          <text-input type="date" v-model="form.data_carico" :error="form.errors.data_carico" class="pr-6 pb-8 w-full lg:w-1/2" label="Data Carico" />
          <text-input type="date" v-model="form.data_scarico" :error="form.errors.data_scarico" class="pr-6 pb-8 w-full lg:w-1/2" label="Data Scarico" />
          <text-input v-model="form.prezzo_totale_scarico" :error="form.errors.prezzo_totale_scarico" class="pr-6 pb-8 w-full lg:w-1/2" label="Prezzo Totale Scarico" /> -->

    <!-- <text-input v-model="form.data_carico" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" label="Phone" />
          <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full lg:w-1/2" label="Address" />
          <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-8 w-full lg:w-1/2" label="City" />
          <text-input v-model="form.region" :error="form.errors.region" class="pr-6 pb-8 w-full lg:w-1/2" label="Province/State" />
          <select-input v-model="form.country" :error="form.errors.country" class="pr-6 pb-8 w-full lg:w-1/2" label="Country">
            <option :value="null" />
            <option value="CA">Canada</option>
            <option value="US">United States</option>
          </select-input> 
          <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="pr-6 pb-8 w-full lg:w-1/2" label="Postal code" />-->
    <!-- </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!batch.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Elimina Lotto</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Aggiorna Lotto</loading-button>
        </div>
      </form>
    </div> -->

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-3">SKU</th>
          <th class="px-6 pt-6 pb-3">SKU2</th>
          <th class="px-6 pt-6 pb-3">Nome</th>
          <th class="px-6 pt-6 pb-3">Categoria</th>
          <th class="px-6 pt-6 pb-3">Brand</th>
        </tr>
        <tr v-for="product in products.data" :key="product.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              {{ product.sku }}
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              {{ product.sku2 }}
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              {{ product.name }}
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              {{ product.categoria }}
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              {{ product.brand }}
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="products.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nessun prodotto trovato</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="products.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Pagination from '@/Shared/Pagination'

export default {
  computed: {
    user() {
      return this.$page.props.auth.user
    },
  },
  metaInfo() {
    return {
      title: `${this.form.nome}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Pagination,
  },
  layout: Layout,
  props: {
    batch: Object,
    organizations: Array,
    products: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nome: this.batch.nome,
        organization_id: this.batch.organization_id,
        data_carico: this.batch.data_carico,
        data_scarico: this.batch.data_scarico,
        prezzo_totale_scarico: this.batch.prezzo_totale_scarico,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('batches.update', this.batch.id))
    },
    destroy() {
      if (confirm('Vuoi eliminare questo lotto?')) {
        this.$inertia.delete(this.route('batches.destroy', this.batch.id))
      }
    },
    restore() {
      if (confirm('Vuoi ripristinare questo lotto?')) {
        this.$inertia.put(this.route('batches.restore', this.batch.id))
      }
    },
  },
}
</script>
